import React from 'react'

const SvgComponent = props => (
    <img width={290.333} height={54} viewBox="0 0 226 48" src="/images/logo.png" {...props} />
)

export default SvgComponent